import { TDeviceType } from '@cian/ui-kit';
import * as styles from './styles.css';
import { TListItemProps, TListProps } from 'shared/types/list';
import { EDealType } from 'shared/types/wantType';
import { clsx } from 'clsx';

interface IListProps extends TListProps {
  dealType: EDealType;
  title: string;
  device: TDeviceType;
  ListItem: React.FC<TListItemProps>;
}

export const List: React.FC<IListProps> = ({ list, title, dealType, caCategory, ListItem, device }) => {
  return (
    <div className={clsx(styles['container'], styles[device])}>
      <div className={styles['title']}>{title}</div>
      <div>
        {list.map((item, key) => (
          <ListItem key={key} caCategory={caCategory} item={item} dealType={dealType} />
        ))}
      </div>
    </div>
  );
};
